
export const LOAD_EVENT_LOG_DATA_IN_PROGRESS = "LOAD_EVENT_LOG_DATA_IN_PROGRESS";
export const loadEventLogDataInProgress = () => ({
  type: LOAD_EVENT_LOG_DATA_IN_PROGRESS,
});

export const LOAD_EVENT_LOG_DATA_SUCCESS = "LOAD_EVENT_LOG_DATA_SUCCESS";
export const loadEventLogDataSuccess = (data) => ({
  type: LOAD_EVENT_LOG_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_EVENT_LOG_DATA_FAILURE = "LOAD_EVENT_LOG_DATA_FAILURE";
export const loadEventLogDataFailure = () => ({
  type: LOAD_EVENT_LOG_DATA_FAILURE,
});

export const EVENT_LOG_OPERATION_COMPLETED = "EVENT_LOG_OPERATION_COMPLETED";
export const eventLogOperationCompleted = () => ({
  type: EVENT_LOG_OPERATION_COMPLETED,
});
